import { yupResolver } from "@hookform/resolvers/yup"
import React, { useState, useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import {
  Row,
  Col,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  FormFeedback,
  Spinner,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  UFEditor,
  UFInput,
  UFInputNumber,
} from "../../../components/Common/Fields/Input"
import classnames from "classnames"
import { Link } from "react-router-dom"
import { postInventoryUnit } from "../../../services/Inventory/inventory"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import DesimalPoint from "../../../components/Common/chooseFields/desimalPoint"

const schema = yup.object().shape({
  unit_code: yup.string().required("Unit Code is Required"),
  description: yup.string().required("Description is Required"),
  decimal_place: yup.mixed().required("Decimal is Required"),
})

const EditUnitForm = ({
  loading,
  onUpdate,
  id,
  error,
  close,
  editItem,
  ...props
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  })
  console.log(`props`, props, editItem)

  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (editItem?.modal) {
      reset({ ...editItem?.value,
        decimal_place: editItem?.value?.decimal_place != null
          ? { value: editItem?.value?.decimal_place, label: editItem?.value?.decimal_place }
          : null,
       })
    }
  }, [editItem?.modal])

  const handleUnitAdd = async data => {
    try {
      setIsLoading(true)
      const createdSeries = await postInventoryUnit({...data, decimal_place: data?.decimal_place?.value})
      toastSuccess(createdSeries?.message)
      onUpdate(createdSeries.data) // Pass the new unit data back
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      reset()
      close()
    }
  }

  return (
    <>
      <OffcanvasHeader className="d-flex justify-content-between align-items-center">
        <div className="d-flex justify-content-between w-100">
          <h5 className="editmodelheadtitle m-0 edittheamtitle">
            {editItem?.modal ? "Edit Unit" : "Add Unit"}
          </h5>
          <div className="d-flex gap-2">
            <Button color="secondary" onClick={close} size="sm">
              Close
            </Button>
            <LoadingButton
              form={`unit-form`}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
              size="sm"
            >
              {editItem?.modal ? "Update" : "Save"}
            </LoadingButton>
          </div>
        </div>
      </OffcanvasHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="lg"
          />
        </div>
      ) : (
        <>
          <OffcanvasBody>
            <FormProvider {...methods}>
              <Form
                id={`unit-form`}
                onSubmit={e => {
                  e.preventDefault()
                  e.stopPropagation()
                  handleSubmit(handleUnitAdd)(e)
                }}
              >
                <Row>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Unit Code<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Unit Code"
                        rows="3"
                        name={"unit_code"}
                        invalid={!!errors.unit_code}
                      />
                      <FormFeedback invalid>
                        {errors.unit_code?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Decimal Place<span className="mandatory">*</span>
                      </Label>
                      <DesimalPoint
                        control={control}
                        placeholder="Select Decimal  Point"
                        name={"decimal_place"}
                        invalid={!!errors.decimal_place}
                      />
                      {/* <UFInputNumber
                        control={control}
                        placeholder=""
                        name={"decimal_place"}
                        maxNum={2}
                        invalid={!!errors.decimal_place}
                      /> */}
                      <FormFeedback invalid>
                        {errors.decimal_place?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Description<span className="mandatory">*</span>
                      </Label>
                      <UFEditor
                        control={control}
                        placeholder="Enter the Description"
                        rows="3"
                        name={"description"}
                        invalid={!!errors.description}
                      />
                      <FormFeedback invalid>
                        {errors.description?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </OffcanvasBody>
        </>
      )}
    </>
  )
}

const EditUnit = ({
  buttonLabel,
  className,
  isOpen,
  onClose,
  onCustomerCreated,
  editValue,
  ...props
}) => {
  const [canvas, setCanvas] = useState(false)

  const toggle = () => {
    if (isOpen !== undefined) {
      onClose?.()
    } else {
      setCanvas(!canvas)
    }
  }
  console.log(`editValue`, props)

  const handleSuccess = data => {
    onCustomerCreated?.(data) // Call this when unit is successfully created
    onClose?.()
  }

  useEffect(() => {
    if (isOpen !== undefined) {
      setCanvas(isOpen)
    }
    if (props?.editItem?.modal) {
      setCanvas(true)
    }
  }, [isOpen, props?.editItem?.modal])

  const isOpenState = isOpen !== undefined ? isOpen : canvas

  return (
    <>
      {buttonLabel && (
        <Link to="#" className={className} onClick={toggle}>
          {buttonLabel}
        </Link>
      )}
      <Offcanvas
        isOpen={isOpenState}
        toggle={toggle}
        direction="end"
        className="w-md-50 w-25"
        backdrop={false}
      >
        <EditUnitForm
          close={() => {
            toggle()
            setCanvas(false)
            props?.onReset?.()
          }}
          onUpdate={handleSuccess}
          {...props}
        />
      </Offcanvas>
    </>
  )
}

export default EditUnit
